let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6f3t8")).then(() => parcelRequire('ie54a'));